import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import MostRecent from "../../Components/Product/MostRecent";
import CategorySlider from "../../Components/Product/CategorySlider";
import ProductFilter from "../../Components/Product/ProductFilter";
import ProductGrid from "../../Components/Product/ProductGrid";

class ProductGrid_Waiter extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-12">
          {this.props.RecentView && this.props.RecentView.length !== 0 ? (
            <MostRecent />
          ) : (
            <CategorySlider />
          )}
        </div>
        <div className="col-12">
          <ProductFilter />
        </div>
        <div className="card">
          <div className="card-body">
            <Scrollbars
              style={{ height: "calc(100vh - 30ex)" }}
              className="container-fluid"
            >
              <ProductGrid />
            </Scrollbars>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductGrid_Waiter;
